/**
 * @generated SignedSource<<edeedd6c9a194b04b0c0647c3af207ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GroupTableBody938BadPattern$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"Rows0BadPattern">;
  readonly " $fragmentType": "GroupTableBody938BadPattern";
};
export type GroupTableBody938BadPattern$key = {
  readonly " $data"?: GroupTableBody938BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody938BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "GroupTableBody938BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Rows0BadPattern"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1b12f7f55bdd72978e89e04816e41269";

export default node;
